// extracted by mini-css-extract-plugin
export default {"container":"contact_container__zM6f1","title":"contact_title__M4cll"};